<template>
  <div id="ProjectBanner">
    <div class="content-info">
      <h3>Strainprint</h3>
      <span>{{
        projectData
          .find((x) => x.categoryName === "app")
          .items.find((x) => x.title === "Strainprint")
          .stack.filter((x) => x)
          .join(" \u2022 ")
      }}</span>
      <p
        v-html="
          languageHelper.translate('strainprint.desc', {
            locale: global.locale,
          })
        "
      ></p>

      <div
        class="content-images-mobile"
        @click="
          setModalData({ modalType: 'project', data: strainprintData });
          analyticsHelper.modalOpen('strainprint featured');
        "
      >
        <img
          :src="require('@/assets/images/screenshots/strainprint/demo1.png')"
        />
        <img
          :src="require('@/assets/images/screenshots/strainprint/demo2.png')"
        />
      </div>
      <div class="store-links">
        <a
          @click="analyticsHelper.clickedLink('strainprint - ios store')"
          href="https://apps.apple.com/ca/app/strainprint-cannabis-journal/id1188839244"
          target="_blank"
          ><img :src="require('@/assets/images/icons/appstore.png')"
        /></a>
        <a
          @click="analyticsHelper.clickedLink('strainprint - android store')"
          href="https://play.google.com/store/apps/details?id=com.strainprint&hl=en_CA&gl=US"
          target="_blank"
          ><img :src="require('@/assets/images/icons/playstore.png')"
        /></a>
      </div>
    </div>
    <div
      class="content-images"
      @click="
        setModalData({ modalType: 'project', data: strainprintData });
        analyticsHelper.modalOpen('strainprint featured');
      "
    >
      <img
        :src="require('@/assets/images/screenshots/strainprint/demo1.png')"
      />
      <img
        :src="require('@/assets/images/screenshots/strainprint/demo2.png')"
        v-if="global.screenWidth > 972"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import projectData from "@/data/projectData";
import { languageHelper, analyticsHelper } from "@/helpers";

export default {
  name: "ProjectBanner",
  computed: {
    ...mapState(["global"]),
  },
  data() {
    return {
      strainprintData: projectData[1].items[0],
      languageHelper,
      analyticsHelper,
      projectData,
    };
  },
  methods: {
    ...mapActions(["setModalData"]),
  },
};
</script>

<style lang="scss" scoped>
$smaller-desktop: $xl;
$mobile: $lg;
#ProjectBanner {
  width: 100%;
  min-height: 30vh;
  z-index: 5;
  background: $lt-secondary-color;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px 40px;
  @media (max-width: $smaller-desktop) {
    justify-content: space-between;
    align-items: center;
  }
  @media (max-width: $mobile) {
    padding-left: 16px;
    padding-right: 16px;
  }

  .content-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    width: 100%;
  }
  .store-links {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-top: 80px;
    a {
      outline: none;
      img {
        height: 48px;
        &:first-child {
          margin-right: 16px;
        }
      }
    }
  }
  .content-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    flex: 1;
    max-width: 1100px;
    @media (max-width: $smaller-desktop) {
      justify-content: space-between;
    }
    @media (max-width: $md) {
      align-items: center;
      max-width: 100%;
    }
  }
  .content-images,
  .content-images-mobile {
    img {
      cursor: pointer;
      border-radius: 22px;
    }
  }
  .content-images-mobile {
    display: none;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    margin-top: 80px;
    img {
      width: 220px;
      margin-right: 15px;
      &:last-child {
        margin-right: 0 !important;
      }
    }

    @media (max-width: 509px) {
      img {
        width: 160px;
      }
    }
    @media (max-width: 360px) {
      flex-direction: column;
    }
    @media (max-width: $md) {
      display: flex;
    }
  }
  .content-images {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    img {
      width: auto;
      max-width: 50%;
      max-height: 480px;
      object-fit: contain;
      &:first-child {
        margin-right: 15px;
      }
      @media (max-width: $lg) {
        max-width: 100%;
        max-height: 570px;
      }
      @media (max-width: $md) {
        display: none;
      }
    }
  }

  h3 {
    font-size: 52px;
    font-family: $font-header;
    margin-top: 40px;
    @media (max-width: $md) {
      font-size: 42px;
    }
  }
  span {
    color: $lt-secondary-color-contrast;
    font-size: 17px;
    font-family: $font-header;
    margin-top: 12px;
  }
  p {
    font-size: 20px;
    font-family: $font-primary;
    width: 600px;
    margin-top: 16px;
    @media (max-width: $smaller-desktop) {
      width: 400px;
    }
    @media (max-width: $md) {
      text-align: center;
      margin-top: 60px;
      width: auto;
    }
  }
}
</style>


<style lang="scss" >
$smaller-desktop: $xl;
$mobile: $lg;
.dark {
  #ProjectBanner {
    background: $dt-font-color;

    h3 {
    }
    span {
      color: $dt-secondary-color-contrast;
    }
    p {
    }
  }
}
</style>

